import React from 'react'
import withIcon from '@/components/withIcon'

type TProps = {
  className: string
}

function IconVerifiedCheckMark({ className }: TProps): JSX.Element {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm-1.49 16.804a.696.696 0 0 1-.968 0l-4.346-4.346a.695.695 0 0 1 0-.969l.943-.942a.664.664 0 0 1 .942 0l2.958 2.932 6.283-6.283a.664.664 0 0 1 .942 0l.943.943a.695.695 0 0 1 0 .968l-7.697 7.697Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default withIcon(IconVerifiedCheckMark)
